/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br."Knowledge for Decisions (K4D)" and the slogan"Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from'react';
import { cn } from'@/shared/ui/utils/tailwind';

export type TitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  size?:'xs' |'sm' |'md' |'lg' |'xl';
  component?: React.ElementType;
  className?: string;
};

/**
 * Title component with Tailwind styling
 * Replaces Mantine Title
 */
export const Title: React.FC<TitleProps> = ({
  order = 1,
  size,
  component,
  className,
  style,
  children,
  ...props
}) => {
  const HeadingTag = (component ||`h${order}`) as React.ElementType;
  
  const sizeStyles: Record<string, string> = {
    xs:'var(--text-meta)',
    sm:'var(--text-small)',
    md:'var(--text-body)',
    lg:'var(--text-body-lg)',
    xl:'var(--text-h3)',
  };

  const orderStyles: Record<number, { fontSize: string; fontWeight: string }> = {
    1: { fontSize:'var(--text-h1)', fontWeight:'var(--font-bold)' },
    2: { fontSize:'var(--text-h2)', fontWeight:'var(--font-bold)' },
    3: { fontSize:'var(--text-h3)', fontWeight:'var(--font-semibold)' },
    4: { fontSize:'var(--text-h3)', fontWeight:'var(--font-semibold)' },
    5: { fontSize:'var(--text-h5)', fontWeight:'var(--font-medium)' },
    6: { fontSize:'var(--text-h6)', fontWeight:'var(--font-medium)' },
  };

  const resolved = size
    ? { fontSize: sizeStyles[size] }
    : orderStyles[order];

  return (
    <HeadingTag
      className={cn(
        'text-(--text-primary)',
        className
      )}
      style={{ ...resolved, ...style }}
      {...props}
    >
      {children}
    </HeadingTag>
  );
};

export default Title;
